import type { Resources } from '@fluxora/i18n';

import { shopEn } from '../locales/en';

/**
 * The storefront's i18n resource bundle. Single source shared by the App shell
 * and the test renderer, so `t()` resolves identically in both.
 */
export const shopResources = { 'en-US': { shop: shopEn } } as unknown as Resources;
